/**
 * @generated SignedSource<<71f09d5e2b690e844ef1dffc899d400d>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type shippingHelpers_viewer$data = {
  readonly regionsInfo?: ReadonlyArray<{
    readonly regionsByZipCode: ReadonlyArray<{
      readonly displayName: string | null;
    } | null> | null;
  } | null> | null;
  readonly " $fragmentType": "shippingHelpers_viewer";
};
export type shippingHelpers_viewer$key = {
  readonly " $data"?: shippingHelpers_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"shippingHelpers_viewer">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "shippingHelpers_viewer"
};

(node as any).hash = "cdac6d8401c3c1e0adaf8881151dee3f";

export default node;
